module.exports = __webpack_public_path__ + "c3aeac0dad1dfcc917a721a975ea29dd.svg";